import { render, staticRenderFns } from "./AccordionHeader.vue?vue&type=template&id=41af9d72&"
import script from "./AccordionHeader.vue?vue&type=script&lang=js&"
export * from "./AccordionHeader.vue?vue&type=script&lang=js&"
import style0 from "./AccordionHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports